import {CreateCategory} from './create-category';

export default CreateCategory;
